/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  function initProductColorSwatches(root) {
    root.querySelectorAll('.product-color-swatches').forEach(function(group) {
      if (group.dataset.hoverLabelsInitialized === 'true') return;

      var label = group.querySelector('.product-color-swatches__label');
      if (!label) return;

      var activeName = label.textContent.trim();

      group.addEventListener('mouseover', function(event) {
        var swatch = event.target.closest('[data-swatch-name]');
        if (swatch && group.contains(swatch)) {
          label.textContent = swatch.dataset.swatchName;
        }
      });

      group.addEventListener('mouseleave', function() {
        label.textContent = activeName;
      });

      group.dataset.hoverLabelsInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initProductColorSwatches(document);
    });
  } else {
    initProductColorSwatches(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initProductColorSwatches(event.target);
  });


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
